<template>
  <head>
    <meta charset="utf-8" />
    <title>CBHI | Community-Based Health Insurance</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Keep your finances and membership up to date" name="description" />
    <meta content="Kelvin Njuguna Ndungu" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body data-sidebar="dark">
  <!-- Begin page -->
  <div id="layout-wrapper">
    <!-- ========== Left Sidebar Start ========== -->
    <NavigationBar/>
    <!-- Left Sidebar End -->

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div class="main-content">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Premium Reconciliation Management</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="javascript: void(0);">Premium Management</a></li>
                    <li class="breadcrumb-item active">Reconciliation</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <!-- Statistics Dashboard -->
          <div class="row">
            <!-- Total Reconciliations -->
            <div class="col-lg-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Reconciliations</p>
                      <h5 class="mb-0">{{ statistics ? (statistics.total_reconciliations || 0) : 0 }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-primary rounded-circle text-white font-size-20">
                        <i class="bx bx-file"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Total Amount -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Total Amount</p>
                      <h5 class="mb-0">ETB {{ formatAmount(statistics ? (statistics.total_amount || 0) : 0) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-success rounded-circle text-white font-size-20">
                        <i class="bx bx-money"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Matched Amount -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Matched Amount</p>
                      <h5 class="mb-0">ETB {{ formatAmount(statistics ? (statistics.total_matched || 0) : 0) }}</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-info rounded-circle text-white font-size-20">
                        <i class="bx bx-check-circle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Average Match Rate -->
            <div class="col-lg-3 col-md-6">
              <div class="card blog-stats-wid">
                <div class="card-body">
                  <div class="d-flex flex-wrap">
                    <div class="me-3">
                      <p class="text-muted mb-2">Avg. Match Rate</p>
                      <h5 class="mb-0">{{ statistics ? (statistics.avg_match_rate || 0).toFixed(1) : '0.0' }}%</h5>
                    </div>
                    <div class="avatar-sm ms-auto">
                      <div class="avatar-title bg-warning rounded-circle text-white font-size-20">
                        <i class="bx bx-trending-up"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white border-bottom">
                  <!-- Ethiopian/Gregorian Date Filter -->
                  <div class="bg-light border rounded p-2 mb-3">
                    <!-- Row 1: Calendar Toggle + Date Selection -->
                    <div class="row g-2 align-items-center">
                      <div class="col-auto">
                        <div class="btn-group btn-group-sm" role="group">
                          <input type="radio" class="btn-check" name="calendarType" id="calEth" :value="true" v-model="showEthiopianDates">
                          <label class="btn btn-outline-primary" for="calEth">
                            <i class="bx bx-calendar"></i> Ethiopian
                          </label>
                          <input type="radio" class="btn-check" name="calendarType" id="calGreg" :value="false" v-model="showEthiopianDates">
                          <label class="btn btn-outline-success" for="calGreg">
                            <i class="bx bx-calendar-alt"></i> Gregorian
                          </label>
                        </div>
                      </div>

                      <div class="col">
                        <div class="row g-2 align-items-center">
                          <!-- From Date -->
                          <div class="col-auto">
                            <span class="badge bg-secondary">From</span>
                          </div>
                          <div class="col-auto">
                            <select v-model="dateFilterRange.fromDay" @change="updateDateRange" class="form-select form-select-sm" style="width: 65px;">
                              <option value="">{{ showEthiopianDates ? 'ቀን' : 'Day' }}</option>
                              <option v-for="d in fromDaysInMonth" :key="d" :value="d">{{ d }}</option>
                            </select>
                          </div>
                          <div class="col-auto">
                            <select v-model="dateFilterRange.fromMonth" @change="onFromMonthChange" class="form-select form-select-sm" style="width: 115px;">
                              <option value="">{{ showEthiopianDates ? 'ወር' : 'Month' }}</option>
                              <option v-for="m in displayMonths" :key="m.value" :value="m.value">{{ showEthiopianDates ? m.label : m.labelShort }}</option>
                            </select>
                          </div>
                          <div class="col-auto">
                            <select v-model="dateFilterRange.fromYear" @change="updateDateRange" class="form-select form-select-sm" style="width: 80px;">
                              <option value="">{{ showEthiopianDates ? 'ዓ/ም' : 'Year' }}</option>
                              <option v-for="y in displayYearOptions" :key="y" :value="y">{{ y }}</option>
                            </select>
                          </div>

                          <!-- Separator -->
                          <div class="col-auto">
                            <span class="text-muted">—</span>
                          </div>

                          <!-- To Date -->
                          <div class="col-auto">
                            <span class="badge bg-secondary">To</span>
                          </div>
                          <div class="col-auto">
                            <select v-model="dateFilterRange.toDay" @change="updateDateRange" class="form-select form-select-sm" style="width: 65px;">
                              <option value="">{{ showEthiopianDates ? 'ቀን' : 'Day' }}</option>
                              <option v-for="d in toDaysInMonth" :key="d" :value="d">{{ d }}</option>
                            </select>
                          </div>
                          <div class="col-auto">
                            <select v-model="dateFilterRange.toMonth" @change="onToMonthChange" class="form-select form-select-sm" style="width: 115px;">
                              <option value="">{{ showEthiopianDates ? 'ወር' : 'Month' }}</option>
                              <option v-for="m in displayMonths" :key="m.value" :value="m.value">{{ showEthiopianDates ? m.label : m.labelShort }}</option>
                            </select>
                          </div>
                          <div class="col-auto">
                            <select v-model="dateFilterRange.toYear" @change="updateDateRange" class="form-select form-select-sm" style="width: 80px;">
                              <option value="">{{ showEthiopianDates ? 'ዓ/ም' : 'Year' }}</option>
                              <option v-for="y in displayYearOptions" :key="y" :value="y">{{ y }}</option>
                            </select>
                          </div>

                          <!-- Action Buttons -->
                          <div class="col-auto">
                            <button type="button" class="btn btn-primary btn-sm" @click="applyDateFilter" :disabled="!isValidDateRange" title="Apply Filter">
                              <i class="bx bx-filter-alt"></i>
                            </button>
                          </div>
                          <div class="col-auto" v-if="hasDateSelection">
                            <button type="button" class="btn btn-outline-danger btn-sm" @click="clearDateSelection" title="Clear Date Filter">
                              <i class="bx bx-x"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Row 2: Alternate Calendar Display -->
                    <div class="row mt-2" v-if="alternateDateDisplay">
                      <div class="col-12">
                        <small :class="showEthiopianDates ? 'text-success' : 'text-primary'">
                          <i class="bx bx-calendar-check me-1"></i>
                          <strong>{{ showEthiopianDates ? 'Gregorian' : 'Ethiopian' }}:</strong>
                          {{ alternateDateDisplay }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <!-- Other Filters Row -->
                  <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
                    <div class="d-flex flex-wrap gap-2">
                      <!-- Status Filter -->
                      <button type="button" class="btn btn-light waves-effect btn-sm" :class="{'active': filters.status}" @click="toggleStatusFilter">
                        <i class="bx bx-filter font-size-16 me-1 align-middle"></i>
                        {{ filters.status ? filters.status : 'All Status' }}
                      </button>

                      <!-- Bank Source Filter -->
                      <div class="btn-group">
                        <button type="button" class="btn btn-light waves-effect btn-sm" data-bs-toggle="dropdown" aria-expanded="false">
                          <i class="bx bx-building-house font-size-16 me-1 align-middle"></i>
                          {{ filters.bankSource || 'All Banks' }}
                        </button>
                        <div class="dropdown-menu p-2">
                          <a class="dropdown-item" href="#" @click.prevent="setBankFilter('')">All Banks</a>
                          <div class="dropdown-divider"></div>
                          <a v-for="source in bankSources" :key="source.bank_source"
                             class="dropdown-item" href="#"
                             @click.prevent="setBankFilter(source.bank_source)">
                            {{ source.bank_source }}
                          </a>
                        </div>
                      </div>

                      <!-- Clear Filters -->
                      <button v-if="hasActiveFilters" type="button" class="btn btn-danger waves-effect btn-sm" @click="clearFilters">
                        <i class="bx bx-x font-size-16 me-1 align-middle"></i> Clear All
                      </button>
                    </div>

                    <div class="d-flex gap-2 align-items-center">
                      <!-- Search -->
                      <div class="search-box mb-0">
                        <div class="position-relative">
                          <input v-model="searchQuery" @input="searchReconciliations" type="text"
                                 class="form-control form-control-sm bg-light border-light rounded"
                                 placeholder="Search..." style="width: 180px;" spellcheck="false">
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>

                      <!-- Upload Button -->
                      <button @click="showUploadModal = true" type="button" class="btn btn-success btn-sm">
                        <i class="fas fa-upload me-1"></i> Upload
                      </button>

                      <!-- Export -->
                      <button @click="exportReport" type="button" class="btn btn-primary btn-sm">
                        <i class="bx bxs-download me-1"></i> Export
                      </button>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                    <p class="mt-3">Loading reconciliation records...</p>
                  </div>

                  <!-- Data Table -->
                  <div v-else-if="reconciliations && reconciliations.length > 0" class="table-responsive">
                    <table class="table align-middle table-hover border table-striped text-nowrap mb-0">
                      <thead class="table-light">
                      <tr>
                        <th scope="col">No.</th>
                        <th scope="col">Document</th>
                        <th scope="col">Period</th>
                        <th scope="col">Bank/Source</th>
                        <th scope="col">Records</th>
                        <th scope="col">Match Rate</th>
                        <th scope="col">Reason</th>
                        <th scope="col">Uploaded by</th>
                        <th scope="col">Status</th>
                        <th scope="col">Uploaded</th>
                        <th scope="col" class="text-end">Amount (ETB)</th>
                        <th scope="col" class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(reconciliation, index) in reconciliations" :key="reconciliation.reconciliation_id">
                        <td>{{ (currentPage - 1) * limit + index + 1 }}</td>
                        <td>{{ reconciliation.document_name }}</td>
                        <td>{{ formatDateDisplay(reconciliation.period) }}</td>
                        <td>
                          <p class="fw-semibold mb-1">{{ reconciliation.bank_source }}</p>
                          <span v-if="reconciliation.bank_account">Account: {{ maskAccountNumber(reconciliation.bank_account) }}</span>
                        </td>
                        <td>
                          <div class="progress" style="height: 20px;">
                            <div class="progress-bar" role="progressbar"
                                 :style="{ width: (reconciliation.match_percentage || 0) + '%' }"
                                 :class="getProgressBarClass(reconciliation.match_percentage || 0)">
                              {{ reconciliation.match_percentage || 0 }}%
                            </div>
                          </div>
                          <span class="text-muted">{{ reconciliation.records_info }}</span>
                        </td>
                        <td>
                          <span :class="getMatchRateBadge(reconciliation.match_percentage || 0)">
                            {{ reconciliation.match_percentage || 0 }}%
                          </span>
                        </td>
                        <td>{{ reconciliation.reason || '-' }}</td>
                        <td>{{ reconciliation.uploaded_by }}</td>
                        <td>
                          <span :class="getStatusBadge(reconciliation.status)">
                            {{ reconciliation.status }}
                          </span>
                        </td>
                        <td>{{ formatDateDisplay(reconciliation.upload_date) }}</td>
                        <td class="text-end">{{ formatAmount(reconciliation.total_amount) }}</td>
                        <td class="text-center">
                          <button @click="viewDetails(reconciliation)" class="btn btn-sm btn-primary me-1" title="View Details">
                            <i class="bx bx-show"></i>
                          </button>
                          <button @click="downloadReport(reconciliation)" class="btn btn-sm btn-success" title="Download Report">
                            <i class="bx bx-download"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>

                  <!-- No Data State -->
                  <div v-else class="text-center py-5">
                    <i class="bx bx-file text-muted" style="font-size: 48px;"></i>
                    <p class="mt-3 text-muted">No reconciliation records found</p>
                    <button @click="showUploadModal = true" class="btn btn-primary mt-3">
                      <i class="fas fa-upload me-2"></i>Upload Your First Statement
                    </button>
                  </div>

                  <!-- Pagination -->
                  <div v-if="totalPages > 1" class="row mt-4">
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_info">
                        Showing {{ (currentPage - 1) * limit + 1 }} to {{ Math.min(currentPage * limit, total) }} of {{ total }} entries
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination">
                          <li class="paginate_button page-item previous" :class="{'disabled': currentPage === 1}">
                            <a @click="changePage(currentPage - 1)" href="#" class="page-link">Previous</a>
                          </li>
                          <li v-for="page in displayedPages" :key="page" class="paginate_button page-item" :class="{'active': page === currentPage}">
                            <a @click="changePage(page)" href="#" class="page-link">{{ page }}</a>
                          </li>
                          <li class="paginate_button page-item next" :class="{'disabled': currentPage === totalPages}">
                            <a @click="changePage(currentPage + 1)" href="#" class="page-link">Next</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- container-fluid -->
      </div>
      <!-- End Page-content -->

      <!-- Upload Statement Modal -->
      <div v-if="showUploadModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-lg modal-dialog-centered">
          <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
              <h5 class="modal-title">Upload Bank Statement</h5>
              <button type="button" class="btn-close" @click="closeUploadModal"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
              <form @submit.prevent="uploadStatement">
                <!-- File Upload Section -->
                <div class="mb-4">
                  <label class="form-label">
                    Select Statement File <span class="text-danger">*</span>
                  </label>
                  <div class="file-drop-zone"
                       :class="{'drag-active': isDragging}"
                       @dragover.prevent="isDragging = true"
                       @dragleave.prevent="isDragging = false"
                       @drop.prevent="handleFileDrop"
                       @click="$refs.fileInput.click()">
                    <div v-if="selectedFile" class="d-flex align-items-center justify-content-center">
                      <i :class="getFileIcon(selectedFile.type)" class="fs-1 me-3"></i>
                      <div>
                        <div class="fw-bold">{{ selectedFile.name }}</div>
                        <small class="text-muted">{{ formatFileSize(selectedFile.size) }}</small>
                      </div>
                    </div>
                    <div v-else>
                      <i class="fas fa-cloud-upload-alt fa-3x text-muted mb-3"></i>
                      <p class="mb-2">Drop your file here or click to browse</p>
                      <small class="text-muted">CSV files only (.csv)</small>
                    </div>
                    <input ref="fileInput" type="file" @change="handleFileSelect"
                           accept=".csv" class="d-none">
                  </div>
                  <div v-if="uploadError" class="alert alert-danger mt-2">{{ uploadError }}</div>
                </div>

                <!-- Statement Details -->
                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="documentName" class="form-label">
                      Document Name <span class="text-danger">*</span>
                    </label>
                    <input v-model="uploadData.documentName" type="text" class="form-control"
                           id="documentName" required placeholder="e.g., January 2025 Bank Statement">
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="period" class="form-label">
                      Period <span class="text-danger">*</span>
                    </label>
                    <input v-model="uploadData.period" type="month" class="form-control"
                           id="period" required>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 mb-3">
                    <label for="bankSource" class="form-label">
                      Bank/Source <span class="text-danger">*</span>
                    </label>
                    <select v-model="uploadData.bankSource" class="form-select" id="bankSource" required>
                      <option value="">Select bank/source</option>
                      <option v-for="source in bankSources" :key="source.bank_source" :value="source.bank_source">
                        {{ source.bank_source }}
                      </option>
                    </select>
                  </div>

                  <div class="col-md-6 mb-3">
                    <label for="bankAccount" class="form-label">
                      Account Number
                    </label>
                    <input v-model="uploadData.bankAccount" type="text" class="form-control"
                           id="bankAccount" placeholder="e.g., 1000123456">
                  </div>
                </div>

                <!-- Upload Reason -->
                <div class="mb-3">
                  <label for="uploadReason" class="form-label">
                    Reason for Upload <span class="text-danger">*</span>
                  </label>
                  <select v-model="uploadData.reason" class="form-select" id="uploadReason" required>
                    <option value="">Select reason</option>
                    <option value="Monthly Reconciliation">Monthly Reconciliation</option>
                    <option value="Audit Requirements">Audit Requirements</option>
                    <option value="Financial Review">Financial Review</option>
                    <option value="Budget Analysis">Budget Analysis</option>
                    <option value="Compliance Check">Compliance Check</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <!-- Preview Section -->
                <div v-if="filePreview.length > 0" class="mb-3">
                  <h6 class="mb-2">File Preview</h6>
                  <div class="table-responsive" style="max-height: 200px; overflow-y: auto;">
                    <table class="table table-sm table-bordered">
                      <thead>
                      <tr>
                        <th>Date</th>
                        <th>Reference</th>
                        <th>Amount</th>
                        <th>Description</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(row, index) in filePreview.slice(0, 5)" :key="index">
                        <td>{{ row.date || '-' }}</td>
                        <td>{{ row.reference || '-' }}</td>
                        <td>{{ row.amount || '-' }}</td>
                        <td>{{ row.description || '-' }}</td>
                      </tr>
                      </tbody>
                    </table>
                    <p v-if="filePreview.length > 5" class="text-muted mb-0">
                      Showing 5 of {{ filePreview.length }} records
                    </p>
                  </div>
                </div>
              </form>
            </div>

            <!-- Modal Footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeUploadModal">
                <i class="fas fa-times me-2"></i>Cancel
              </button>
              <button type="button" class="btn btn-primary" @click="uploadStatement"
                      :disabled="!selectedFile || uploading">
                <span v-if="uploading">
                  <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                  Uploading...
                </span>
                <span v-else>
                  <i class="fas fa-upload me-2"></i>Upload Statement
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Reconciliation Details Modal -->
      <div v-if="showDetailsModal" class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Reconciliation Details</h5>
              <button type="button" class="btn-close" @click="closeDetailsModal"></button>
            </div>
            <div class="modal-body" v-if="selectedReconciliation">
              <!-- Reconciliation Summary -->
              <div class="row mb-4">
                <div class="col-md-6">
                  <div class="card h-100 border">
                    <div class="card-header bg-light">
                      <h6 class="mb-0"><i class="bx bx-info-circle me-1"></i>Reconciliation Information</h6>
                    </div>
                    <div class="card-body">
                      <table class="table table-borderless table-sm">
                        <tr>
                          <td class="text-muted">Document:</td>
                          <td>{{ selectedReconciliation.document_name }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Period:</td>
                          <td>{{ formatDateDisplay(selectedReconciliation.period) }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Bank/Source:</td>
                          <td>{{ selectedReconciliation.bank_source }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Account:</td>
                          <td>{{ selectedReconciliation.bank_account || '-' }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Upload Date:</td>
                          <td>{{ formatDateTimeDisplay(selectedReconciliation.upload_date) }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Uploaded By:</td>
                          <td>{{ selectedReconciliation.uploaded_by }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="card h-100 border">
                    <div class="card-header bg-light">
                      <h6 class="mb-0"><i class="bx bx-calculator me-1"></i>Reconciliation Summary</h6>
                    </div>
                    <div class="card-body">
                      <table class="table table-borderless table-sm">
                        <tr>
                          <td class="text-muted">Total Records:</td>
                          <td>{{ selectedReconciliation.total_records }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Matched Records:</td>
                          <td class="text-success">{{ selectedReconciliation.matched_records }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Unmatched Records:</td>
                          <td class="text-danger">{{ selectedReconciliation.unmatched_records }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Total Amount:</td>
                          <td>ETB {{ formatAmount(selectedReconciliation.total_amount) }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Matched Amount:</td>
                          <td class="text-success">ETB {{ formatAmount(selectedReconciliation.matched_amount) }}</td>
                        </tr>
                        <tr>
                          <td class="text-muted">Match Rate:</td>
                          <td>
                            <div class="progress" style="height: 20px;">
                              <div class="progress-bar" role="progressbar"
                                   :style="{ width: (selectedReconciliation.match_percentage || 0) + '%' }"
                                   :class="getProgressBarClass(selectedReconciliation.match_percentage || 0)">
                                {{ selectedReconciliation.match_percentage || 0 }}%
                              </div>
                            </div>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Loading State for Details -->
              <div v-if="loadingDetails" class="card">
                <div class="card-body text-center py-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                  <p class="mt-3">Loading transaction details...</p>
                </div>
              </div>

              <!-- Match Details -->
              <div v-else-if="reconciliationDetails && reconciliationDetails.length > 0" class="card">
                <div class="card-header bg-light">
                  <h6 class="mb-0"><i class="bx bx-list-ul me-1"></i>Transaction Details</h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table table-sm">
                      <thead>
                      <tr>
                        <th>Bank Reference</th>
                        <th>Amount</th>
                        <th>Date</th>
                        <th>Status</th>
                        <th>Matched To</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(detail, index) in reconciliationDetails" :key="index">
                        <td>{{ detail.bank_reference }}</td>
                        <td>ETB {{ formatAmount(detail.amount) }}</td>
                        <td>{{ formatDateDisplay(detail.date) }}</td>
                        <td>
                          <span v-if="detail.matched" class="badge bg-success">Matched</span>
                          <span v-else class="badge bg-danger">Unmatched</span>
                        </td>
                        <td>
                            <span v-if="detail.matched">
                              {{ detail.member_name }} ({{ detail.cbhi_number }})
                            </span>
                          <span v-else class="text-muted">-</span>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- No Details Message -->
              <div v-else class="card">
                <div class="card-body text-center py-4">
                  <i class="bx bx-info-circle text-muted" style="font-size: 48px;"></i>
                  <p class="mt-3 text-muted">No transaction details available for this reconciliation.</p>
                  <p class="text-muted">Sample data will be included in the downloaded report.</p>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-primary" @click="downloadDetailedReport">
                <i class="bx bx-download me-1"></i>Download Detailed Report
              </button>
              <button type="button" class="btn btn-secondary" @click="closeDetailsModal">
                <i class="bx bx-x me-1"></i>Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Alerts -->
      <div v-if="alert.success" class="position-fixed top-0 end-0 p-3" style="z-index: 9999;">
        <div class="alert alert-success alert-dismissible fade show" role="alert">
          <i class="bx bx-check-circle me-2"></i>
          {{ message }}
          <button type="button" class="btn-close" @click="clearAlerts"></button>
        </div>
      </div>

      <div v-if="alert.failed" class="position-fixed top-0 end-0 p-3" style="z-index: 9999;">
        <div class="alert alert-danger alert-dismissible fade show" role="alert">
          <i class="bx bx-error-circle me-2"></i>
          {{ message }}
          <button type="button" class="btn-close" @click="clearAlerts"></button>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">© CBHI</div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Ministry of Health - Ethiopia
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    <!-- end main content-->
  </div>
  <!-- END layout-wrapper -->

  <!-- Right bar overlay-->
  <div class="rightbar-overlay"></div>
  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "PremiumReconciliation",
  components: { NavigationBar },
  data() {
    return {
      // Loading states
      loading: false,
      uploading: false,
      isLoadingData: false,

      // Data
      reconciliations: [],
      bankSources: [],
      selectedReconciliation: null,
      reconciliationDetails: null,

      // Statistics
      statistics: {
        total_reconciliations: 0,
        total_amount: 0,
        total_matched: 0,
        total_unmatched: 0,
        avg_match_rate: 0
      },

      // Ethiopian/Gregorian Calendar
      showEthiopianDates: true,
      currentEthiopianDate: { year: 2017, month: 3, day: 15, monthName: 'ህዳር', monthNameEn: 'Hidar' },

      // Date Filter Range (works for both Ethiopian and Gregorian)
      dateFilterRange: {
        fromDay: '',
        fromMonth: '',
        fromYear: '',
        toDay: '',
        toMonth: '',
        toYear: ''
      },

      // Ethiopian months list
      ethiopianMonths: [
        { value: 1, label: 'መስከረም', labelEn: 'Meskerem' },
        { value: 2, label: 'ጥቅምት', labelEn: 'Tikimt' },
        { value: 3, label: 'ህዳር', labelEn: 'Hidar' },
        { value: 4, label: 'ታህሳስ', labelEn: 'Tahsas' },
        { value: 5, label: 'ጥር', labelEn: 'Tir' },
        { value: 6, label: 'የካቲት', labelEn: 'Yekatit' },
        { value: 7, label: 'መጋቢት', labelEn: 'Megabit' },
        { value: 8, label: 'ሚያዝያ', labelEn: 'Miyazya' },
        { value: 9, label: 'ግንቦት', labelEn: 'Ginbot' },
        { value: 10, label: 'ሰኔ', labelEn: 'Sene' },
        { value: 11, label: 'ሐምሌ', labelEn: 'Hamle' },
        { value: 12, label: 'ነሐሴ', labelEn: 'Nehase' },
        { value: 13, label: 'ጳጉሜ', labelEn: 'Pagume' }
      ],

      // Gregorian months list
      gregorianMonths: [
        { value: 1, label: 'January', labelShort: 'Jan' },
        { value: 2, label: 'February', labelShort: 'Feb' },
        { value: 3, label: 'March', labelShort: 'Mar' },
        { value: 4, label: 'April', labelShort: 'Apr' },
        { value: 5, label: 'May', labelShort: 'May' },
        { value: 6, label: 'June', labelShort: 'Jun' },
        { value: 7, label: 'July', labelShort: 'Jul' },
        { value: 8, label: 'August', labelShort: 'Aug' },
        { value: 9, label: 'September', labelShort: 'Sep' },
        { value: 10, label: 'October', labelShort: 'Oct' },
        { value: 11, label: 'November', labelShort: 'Nov' },
        { value: 12, label: 'December', labelShort: 'Dec' }
      ],

      // Filters (for API - always Gregorian)
      filters: {
        startDate: '',
        endDate: '',
        status: '',
        bankSource: ''
      },

      // Search
      searchQuery: '',
      searchTimeout: null,

      // Pagination
      currentPage: 1,
      limit: 50,
      total: 0,

      // UI States
      showUploadModal: false,
      showDetailsModal: false,
      isDragging: false,
      loadingDetails: false,

      // Upload data
      selectedFile: null,
      filePreview: [],
      uploadData: {
        documentName: '',
        period: '',
        bankSource: '',
        bankAccount: '',
        reason: ''
      },
      uploadError: '',

      // Alert states
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    };
  },

  watch: {
    loading(newVal, oldVal) {
      console.log('Loading state changed from', oldVal, 'to', newVal);
    },
    // Clear date filter selections when calendar type is toggled
    showEthiopianDates() {
      this.dateFilterRange = { fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: '' };
    }
  },

  computed: {
    totalPages() {
      return Math.ceil(this.total / this.limit);
    },

    displayedPages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      return pages;
    },

    hasActiveFilters() {
      return this.filters.startDate || this.filters.endDate || this.filters.status || this.filters.bankSource;
    },

    // Ethiopian year options
    ethiopianYearOptions() {
      const years = [];
      for (let y = this.currentEthiopianDate.year - 20; y <= this.currentEthiopianDate.year + 5; y++) {
        years.push(y);
      }
      return years;
    },

    // Gregorian year options
    gregorianYearOptions() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let y = currentYear - 20; y <= currentYear + 5; y++) {
        years.push(y);
      }
      return years;
    },

    // Display months based on calendar type
    displayMonths() {
      return this.showEthiopianDates ? this.ethiopianMonths : this.gregorianMonths;
    },

    // Display years based on calendar type
    displayYearOptions() {
      return this.showEthiopianDates ? this.ethiopianYearOptions : this.gregorianYearOptions;
    },

    // Days in FROM month
    fromDaysInMonth() {
      if (this.showEthiopianDates) {
        return this.getDaysInEthiopianMonth(this.dateFilterRange.fromMonth, this.dateFilterRange.fromYear);
      } else {
        return this.getDaysInGregorianMonth(this.dateFilterRange.fromMonth, this.dateFilterRange.fromYear);
      }
    },

    // Days in TO month
    toDaysInMonth() {
      if (this.showEthiopianDates) {
        return this.getDaysInEthiopianMonth(this.dateFilterRange.toMonth, this.dateFilterRange.toYear);
      } else {
        return this.getDaysInGregorianMonth(this.dateFilterRange.toMonth, this.dateFilterRange.toYear);
      }
    },

    // Check if any date is selected
    hasDateSelection() {
      return (this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear) ||
          (this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear);
    },

    // Check if date range is valid
    isValidDateRange() {
      return this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear &&
          this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear;
    },

    // Display alternate calendar date (Ethiopian shows Gregorian, Gregorian shows Ethiopian)
    alternateDateDisplay() {
      if (!this.isValidDateRange) return '';

      if (this.showEthiopianDates) {
        // Currently Ethiopian, show Gregorian equivalent
        const fromGreg = this.ethiopianToGregorian(
            parseInt(this.dateFilterRange.fromYear),
            parseInt(this.dateFilterRange.fromMonth),
            parseInt(this.dateFilterRange.fromDay)
        );
        const toGreg = this.ethiopianToGregorian(
            parseInt(this.dateFilterRange.toYear),
            parseInt(this.dateFilterRange.toMonth),
            parseInt(this.dateFilterRange.toDay)
        );

        if (!fromGreg || !toGreg) return '';

        const formatDate = (d) => d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
        return `${formatDate(fromGreg)} — ${formatDate(toGreg)}`;
      } else {
        // Currently Gregorian, show Ethiopian equivalent
        const fromEth = this.gregorianToEthiopian(new Date(
            parseInt(this.dateFilterRange.fromYear),
            parseInt(this.dateFilterRange.fromMonth) - 1,
            parseInt(this.dateFilterRange.fromDay)
        ));
        const toEth = this.gregorianToEthiopian(new Date(
            parseInt(this.dateFilterRange.toYear),
            parseInt(this.dateFilterRange.toMonth) - 1,
            parseInt(this.dateFilterRange.toDay)
        ));

        if (!fromEth || !toEth) return '';

        return `${fromEth.monthNameEn} ${fromEth.day}, ${fromEth.year} — ${toEth.monthNameEn} ${toEth.day}, ${toEth.year}`;
      }
    }
  },

  mounted() {
    this.currentEthiopianDate = this.getCurrentEthiopianDate();
    this.$nextTick(() => {
      this.initializeAndLoad();
    });
  },

  methods: {
    checkAuth() {
      const token = localStorage.getItem("authToken");
      if (!token) {
        router.push('/login');
      }
    },

    // ==================== ETHIOPIAN CALENDAR METHODS ====================

    // Get days in Ethiopian month
    getDaysInEthiopianMonth(month, year) {
      if (!month || !year) return 30;
      const m = parseInt(month);
      const y = parseInt(year);
      if (m === 13) {
        return (y % 4 === 3) ? 6 : 5; // Pagume: 6 days in leap year, 5 otherwise
      }
      return 30;
    },

    // Get days in Gregorian month
    getDaysInGregorianMonth(month, year) {
      if (!month || !year) return 31;
      const m = parseInt(month);
      const y = parseInt(year);

      // Months with 31 days
      if ([1, 3, 5, 7, 8, 10, 12].includes(m)) return 31;
      // Months with 30 days
      if ([4, 6, 9, 11].includes(m)) return 30;
      // February
      if (m === 2) {
        const isLeap = (y % 4 === 0 && y % 100 !== 0) || (y % 400 === 0);
        return isLeap ? 29 : 28;
      }
      return 31;
    },

    // Ethiopian to Gregorian conversion
    ethiopianToGregorian(ethYear, ethMonth, ethDay) {
      const ETHIOPIAN_EPOCH = 1724221;

      const jdn = ETHIOPIAN_EPOCH +
          365 * (ethYear - 1) +
          Math.floor(ethYear / 4) +
          30 * (ethMonth - 1) +
          ethDay - 1;

      const a = jdn + 32044;
      const b = Math.floor((4 * a + 3) / 146097);
      const c = a - Math.floor(146097 * b / 4);
      const d = Math.floor((4 * c + 3) / 1461);
      const e = c - Math.floor(1461 * d / 4);
      const m = Math.floor((5 * e + 2) / 153);

      const day = e - Math.floor((153 * m + 2) / 5) + 1;
      const month = m + 3 - 12 * Math.floor(m / 10);
      const year = 100 * b + d - 4800 + Math.floor(m / 10);

      return new Date(year, month - 1, day);
    },

    // Gregorian to Ethiopian conversion
    gregorianToEthiopian(gregDate) {
      const date = typeof gregDate === 'string' ? new Date(gregDate) : gregDate;
      if (!date || isNaN(date.getTime())) return null;

      const gYear = date.getFullYear();
      const gMonth = date.getMonth() + 1;
      const gDay = date.getDate();

      const a = Math.floor((14 - gMonth) / 12);
      const y = gYear + 4800 - a;
      const m = gMonth + 12 * a - 3;
      const jdn = gDay + Math.floor((153 * m + 2) / 5) + 365 * y +
          Math.floor(y / 4) - Math.floor(y / 100) + Math.floor(y / 400) - 32045;

      const ETHIOPIAN_EPOCH = 1724221;
      const r = (jdn - ETHIOPIAN_EPOCH) % 1461;
      const n = r % 365 + 365 * Math.floor(r / 1460);

      const ethYear = 4 * Math.floor((jdn - ETHIOPIAN_EPOCH) / 1461) +
          Math.floor(r / 365) - Math.floor(r / 1460) + 1;
      const ethMonth = Math.floor(n / 30) + 1;
      const ethDay = n % 30 + 1;

      const monthData = this.ethiopianMonths.find(mon => mon.value === ethMonth);

      return {
        year: ethYear,
        month: ethMonth,
        day: ethDay,
        monthName: monthData?.label || '',
        monthNameEn: monthData?.labelEn || ''
      };
    },

    // Get current Ethiopian date
    getCurrentEthiopianDate() {
      return this.gregorianToEthiopian(new Date());
    },

    // Format date based on calendar preference
    formatDateDisplay(dateString) {
      if (!dateString) return '-';

      if (this.showEthiopianDates) {
        const eth = this.gregorianToEthiopian(dateString);
        if (eth) {
          return `${eth.monthNameEn} ${eth.day}, ${eth.year}`;
        }
      }

      return this.formatDate(dateString);
    },

    // Format datetime based on calendar preference
    formatDateTimeDisplay(dateString) {
      if (!dateString) return '-';

      const date = new Date(dateString);
      const timeStr = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });

      if (this.showEthiopianDates) {
        const eth = this.gregorianToEthiopian(dateString);
        if (eth) {
          return `${eth.monthNameEn} ${eth.day}, ${eth.year} ${timeStr}`;
        }
      }

      return `${this.formatDate(dateString)} ${timeStr}`;
    },

    // Handle FROM month change
    onFromMonthChange() {
      if (this.dateFilterRange.fromDay > this.fromDaysInMonth) {
        this.dateFilterRange.fromDay = this.fromDaysInMonth;
      }
      this.updateDateRange();
    },

    // Handle TO month change
    onToMonthChange() {
      if (this.dateFilterRange.toDay > this.toDaysInMonth) {
        this.dateFilterRange.toDay = this.toDaysInMonth;
      }
      this.updateDateRange();
    },

    // Update date range (convert to Gregorian for API)
    updateDateRange() {
      if (this.dateFilterRange.fromDay && this.dateFilterRange.fromMonth && this.dateFilterRange.fromYear) {
        let fromGreg;
        if (this.showEthiopianDates) {
          fromGreg = this.ethiopianToGregorian(
              parseInt(this.dateFilterRange.fromYear),
              parseInt(this.dateFilterRange.fromMonth),
              parseInt(this.dateFilterRange.fromDay)
          );
        } else {
          fromGreg = new Date(
              parseInt(this.dateFilterRange.fromYear),
              parseInt(this.dateFilterRange.fromMonth) - 1,
              parseInt(this.dateFilterRange.fromDay)
          );
        }
        if (fromGreg) {
          this.filters.startDate = fromGreg.toISOString().split('T')[0];
        }
      }

      if (this.dateFilterRange.toDay && this.dateFilterRange.toMonth && this.dateFilterRange.toYear) {
        let toGreg;
        if (this.showEthiopianDates) {
          toGreg = this.ethiopianToGregorian(
              parseInt(this.dateFilterRange.toYear),
              parseInt(this.dateFilterRange.toMonth),
              parseInt(this.dateFilterRange.toDay)
          );
        } else {
          toGreg = new Date(
              parseInt(this.dateFilterRange.toYear),
              parseInt(this.dateFilterRange.toMonth) - 1,
              parseInt(this.dateFilterRange.toDay)
          );
        }
        if (toGreg) {
          this.filters.endDate = toGreg.toISOString().split('T')[0];
        }
      }
    },

    // Clear date selection only
    clearDateSelection() {
      this.dateFilterRange = { fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: '' };
      this.filters.startDate = '';
      this.filters.endDate = '';
      this.currentPage = 1;
      this.loadReconciliations();
    },

    async initializeAndLoad() {
      if (this.isLoadingData) {
        console.log('Already loading data, skipping...');
        return;
      }

      this.isLoadingData = true;

      try {
        this.reconciliations = [];
        this.bankSources = [];
        this.statistics = {
          total_reconciliations: 0,
          total_amount: 0,
          total_matched: 0,
          total_unmatched: 0,
          avg_match_rate: 0
        };

        await this.loadBankSources();
        await this.loadReconciliations();
      } catch (error) {
        console.error('Error loading data:', error);
      } finally {
        this.isLoadingData = false;
      }
    },

    async loadBankSources() {
      try {
        const res = await executeJson({ function: "getBankSources" }, authUrl);
        if (res.data.success) {
          this.bankSources = res.data.data.bankSources || [];
        }
      } catch (e) {
        console.error("Failed to load bank sources:", e);
      }
    },

    async loadReconciliations() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      const loadingTimeout = setTimeout(() => {
        if (this.loading) {
          console.error('Loading timeout reached');
          this.loading = false;
          this.showAlert('failed', 'Request timed out. Please try again.');
        }
      }, 30000);

      const data = {
        function: "getBankReconciliations",
        startDate: this.filters.startDate,
        endDate: this.filters.endDate,
        status: this.filters.status,
        bankSource: this.filters.bankSource,
        searchTerm: this.searchQuery,
        limit: this.limit,
        offset: (this.currentPage - 1) * this.limit
      };

      try {
        const res = await executeJson(data, authUrl);

        let responseData = res;
        if (res && res.data) {
          responseData = res.data;
        }

        if (responseData && responseData.success) {
          this.reconciliations = responseData.data?.reconciliations || [];
          this.total = parseInt(responseData.data?.total) || 0;

          this.statistics = {
            total_reconciliations: parseInt(responseData.data?.statistics?.total_reconciliations) || 0,
            total_amount: parseFloat(responseData.data?.statistics?.total_amount) || 0,
            total_matched: parseFloat(responseData.data?.statistics?.total_matched) || 0,
            total_unmatched: parseFloat(responseData.data?.statistics?.total_unmatched) || 0,
            avg_match_rate: parseFloat(responseData.data?.statistics?.avg_match_rate) || 0
          };

          console.log('Reconciliations loaded successfully:', this.reconciliations.length, 'records');
        } else {
          console.error('API returned success: false or invalid response');
          this.reconciliations = [];
          this.total = 0;
          this.statistics = {
            total_reconciliations: 0,
            total_amount: 0,
            total_matched: 0,
            total_unmatched: 0,
            avg_match_rate: 0
          };
        }
      } catch (error) {
        console.error("Error in loadReconciliations:", error);
        this.showAlert('failed', 'Failed to load reconciliation records');
        this.reconciliations = [];
        this.total = 0;
        this.statistics = {
          total_reconciliations: 0,
          total_amount: 0,
          total_matched: 0,
          total_unmatched: 0,
          avg_match_rate: 0
        };
      } finally {
        clearTimeout(loadingTimeout);
        this.loading = false;
        this.$forceUpdate();
      }
    },

    async searchReconciliations() {
      this.currentPage = 1;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(async () => {
        await this.loadReconciliations();
      }, 300);
    },

    async applyDateFilter() {
      if (this.isValidDateRange) {
        this.updateDateRange();
        this.currentPage = 1;
        await this.loadReconciliations();
      }
    },

    toggleStatusFilter() {
      const statuses = ['', 'complete', 'processing', 'failed'];
      const currentIndex = statuses.indexOf(this.filters.status);
      this.filters.status = statuses[(currentIndex + 1) % statuses.length];

      this.currentPage = 1;
      this.loadReconciliations();
    },

    setBankFilter(bankSource) {
      this.filters.bankSource = bankSource;
      this.currentPage = 1;
      this.loadReconciliations();
    },

    async clearFilters() {
      this.filters = {
        startDate: '',
        endDate: '',
        status: '',
        bankSource: ''
      };
      this.dateFilterRange = { fromDay: '', fromMonth: '', fromYear: '', toDay: '', toMonth: '', toYear: '' };
      this.searchQuery = '';
      this.currentPage = 1;
      await this.loadReconciliations();
    },

    async changePage(page) {
      if (page < 1 || page > this.totalPages) return;

      this.currentPage = page;
      await this.loadReconciliations();
    },

    // File upload methods
    handleFileDrop(e) {
      this.isDragging = false;
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        this.processFile(files[0]);
      }
    },

    handleFileSelect(e) {
      const files = e.target.files;
      if (files.length > 0) {
        this.processFile(files[0]);
      }
    },

    async processFile(file) {
      this.uploadError = '';

      if (!file.type.includes('csv') && !file.name.match(/\.csv$/i)) {
        this.uploadError = 'Please upload a valid CSV file. Excel files are not supported in this version.';
        return;
      }

      if (file.size > 10 * 1024 * 1024) {
        this.uploadError = 'File size must be less than 10MB';
        return;
      }

      this.selectedFile = file;
      this.parseCSV(file);
    },

    parseCSV(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        try {
          const text = e.target.result;
          const rows = text.split('\n').filter(row => row.trim());

          if (rows.length === 0) {
            this.uploadError = 'File is empty';
            return;
          }

          const headers = this.parseCSVRow(rows[0]).map(h => h.toLowerCase().trim());

          this.filePreview = [];
          for (let i = 1; i < Math.min(rows.length, 11); i++) {
            const values = this.parseCSVRow(rows[i]);
            const row = {};

            headers.forEach((header, index) => {
              row[header] = values[index] || '';
            });

            this.filePreview.push({
              date: row.date || row.transaction_date || row['transaction date'] || '',
              reference: row.reference || row.ref || row['reference no'] || row['reference number'] || '',
              amount: row.amount || row.credit || row.debit || '',
              description: row.description || row.desc || row.narration || row.details || ''
            });
          }
        } catch (error) {
          this.uploadError = 'Failed to parse CSV file. Please check the file format.';
          console.error('CSV parse error:', error);
        }
      };

      reader.onerror = () => {
        this.uploadError = 'Failed to read file';
      };

      reader.readAsText(file);
    },

    parseCSVRow(row) {
      const values = [];
      let current = '';
      let inQuotes = false;

      for (let i = 0; i < row.length; i++) {
        const char = row[i];

        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          values.push(current.trim());
          current = '';
        } else {
          current += char;
        }
      }

      values.push(current.trim());
      return values;
    },

    async uploadStatement() {
      if (!this.selectedFile) {
        this.uploadError = 'Please select a file';
        return;
      }

      if (!this.uploadData.documentName || !this.uploadData.period || !this.uploadData.bankSource || !this.uploadData.reason) {
        this.uploadError = 'Please fill all required fields';
        return;
      }

      this.uploading = true;
      this.uploadError = '';

      const fileData = await this.parseCompleteFile(this.selectedFile);

      const data = {
        function: "uploadBankStatement",
        documentName: this.uploadData.documentName,
        period: this.uploadData.period + '-01',
        bankSource: this.uploadData.bankSource,
        bankAccount: this.uploadData.bankAccount,
        reason: this.uploadData.reason,
        fileData: fileData
      };

      try {
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.showAlert('success', res.data.message);
          this.closeUploadModal();
          await this.loadReconciliations();
        } else {
          this.uploadError = res.data.message || 'Upload failed';
        }
      } catch (e) {
        console.error("Failed to upload statement:", e);
        this.uploadError = 'Failed to upload statement';
      } finally {
        this.uploading = false;
      }
    },

    parseCompleteFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          try {
            const text = e.target.result;
            const rows = text.split('\n').filter(row => row.trim());

            if (rows.length === 0) {
              reject(new Error('File is empty'));
              return;
            }

            const headers = this.parseCSVRow(rows[0]).map(h => h.toLowerCase().trim());

            const data = [];
            for (let i = 1; i < rows.length; i++) {
              const values = this.parseCSVRow(rows[i]);
              const row = {};

              headers.forEach((header, index) => {
                row[header] = values[index] || '';
              });

              data.push({
                date: row.date || row.transaction_date || row['transaction date'] || '',
                reference: row.reference || row.ref || row['reference no'] || row['reference number'] || '',
                amount: parseFloat(row.amount || row.credit || row.debit || '0'),
                description: row.description || row.desc || row.narration || row.details || ''
              });
            }

            resolve(data);
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = () => {
          reject(new Error('Failed to read file'));
        };

        reader.readAsText(file);
      });
    },

    async viewDetails(reconciliation) {
      this.selectedReconciliation = reconciliation;
      this.showDetailsModal = true;
      this.reconciliationDetails = null;

      try {
        const res = await executeJson({
          function: "getReconciliationDetails",
          reconciliationId: reconciliation.reconciliation_id
        }, authUrl);

        if (res.data.success && res.data.data.details) {
          this.reconciliationDetails = res.data.data.details;
        } else {
          this.reconciliationDetails = this.generateMockDetails(reconciliation);
        }
      } catch (e) {
        console.error("Failed to load reconciliation details:", e);
        this.reconciliationDetails = this.generateMockDetails(reconciliation);
      }
    },

    generateMockDetails(reconciliation) {
      const details = [];
      const totalRecords = parseInt(reconciliation.total_records) || 0;

      for (let i = 0; i < Math.min(totalRecords, 10); i++) {
        details.push({
          bank_reference: `REF${reconciliation.reconciliation_id}${String(i + 1).padStart(3, '0')}`,
          amount: (Math.random() * 5000 + 100).toFixed(2),
          date: reconciliation.period,
          matched: i < parseInt(reconciliation.matched_records),
          member_name: i < parseInt(reconciliation.matched_records) ? `Member ${i + 1}` : null,
          cbhi_number: i < parseInt(reconciliation.matched_records) ? `CBHI${String(i + 1).padStart(6, '0')}` : null
        });
      }

      return details;
    },

    async downloadReport(reconciliation) {
      try {
        const csvContent = this.generateReconciliationCSV(reconciliation);

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `reconciliation_${reconciliation.document_name.replace(/\s+/g, '_')}_${reconciliation.reconciliation_id}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);

        this.showAlert('success', 'Report downloaded successfully');
      } catch (e) {
        console.error("Failed to download report:", e);
        this.showAlert('failed', 'Failed to download report');
      }
    },

    async downloadDetailedReport() {
      if (this.selectedReconciliation && this.reconciliationDetails) {
        try {
          const csvContent = this.generateDetailedReconciliationCSV(this.selectedReconciliation, this.reconciliationDetails);

          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `detailed_reconciliation_${this.selectedReconciliation.document_name.replace(/\s+/g, '_')}_${this.selectedReconciliation.reconciliation_id}.csv`;
          link.click();
          window.URL.revokeObjectURL(url);

          this.showAlert('success', 'Detailed report downloaded successfully');
        } catch (e) {
          console.error("Failed to download detailed report:", e);
          this.showAlert('failed', 'Failed to download detailed report');
        }
      }
    },

    async exportReport() {
      try {
        const csvContent = this.generateFullReportCSV();

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const date = new Date().toISOString().split('T')[0];
        link.download = `reconciliation_report_${date}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);

        this.showAlert('success', 'Report exported successfully');
      } catch (e) {
        console.error("Failed to export report:", e);
        this.showAlert('failed', 'Failed to export report');
      }
    },

    generateReconciliationCSV(reconciliation) {
      const headers = [
        'Reconciliation ID',
        'Document Name',
        'Period',
        'Bank/Source',
        'Account Number',
        'Total Records',
        'Matched Records',
        'Unmatched Records',
        'Match Rate (%)',
        'Total Amount',
        'Matched Amount',
        'Reason',
        'Status',
        'Uploaded By',
        'Upload Date'
      ];

      const data = [
        reconciliation.reconciliation_id,
        reconciliation.document_name,
        this.formatDateDisplay(reconciliation.period),
        reconciliation.bank_source,
        reconciliation.bank_account || 'N/A',
        reconciliation.total_records,
        reconciliation.matched_records,
        reconciliation.unmatched_records,
        reconciliation.match_percentage || 0,
        reconciliation.total_amount,
        reconciliation.matched_amount,
        reconciliation.reason,
        reconciliation.status,
        reconciliation.uploaded_by,
        this.formatDateTimeDisplay(reconciliation.upload_date)
      ];

      let csv = headers.join(',') + '\n';
      csv += data.map(field => this.escapeCSVField(field)).join(',') + '\n';

      return csv;
    },

    generateDetailedReconciliationCSV(reconciliation, details) {
      let csv = 'RECONCILIATION SUMMARY\n';
      csv += 'Document Name,' + this.escapeCSVField(reconciliation.document_name) + '\n';
      csv += 'Period,' + this.formatDateDisplay(reconciliation.period) + '\n';
      csv += 'Bank/Source,' + this.escapeCSVField(reconciliation.bank_source) + '\n';
      csv += 'Account Number,' + (reconciliation.bank_account || 'N/A') + '\n';
      csv += 'Total Records,' + reconciliation.total_records + '\n';
      csv += 'Matched Records,' + reconciliation.matched_records + '\n';
      csv += 'Unmatched Records,' + reconciliation.unmatched_records + '\n';
      csv += 'Match Rate,' + (reconciliation.match_percentage || 0) + '%\n';
      csv += 'Total Amount,ETB ' + this.formatAmount(reconciliation.total_amount) + '\n';
      csv += 'Matched Amount,ETB ' + this.formatAmount(reconciliation.matched_amount) + '\n';
      csv += '\n';

      csv += 'TRANSACTION DETAILS\n';
      const headers = ['Bank Reference', 'Amount', 'Date', 'Status', 'Matched To'];
      csv += headers.join(',') + '\n';

      if (details && details.length > 0) {
        details.forEach(detail => {
          const row = [
            this.escapeCSVField(detail.bank_reference),
            'ETB ' + this.formatAmount(detail.amount),
            this.formatDateDisplay(detail.date),
            detail.matched ? 'Matched' : 'Unmatched',
            detail.matched ? `${detail.member_name} (${detail.cbhi_number})` : 'N/A'
          ];
          csv += row.map(field => this.escapeCSVField(field)).join(',') + '\n';
        });
      }

      return csv;
    },

    generateFullReportCSV() {
      const headers = [
        'No.',
        'Document Name',
        'Period',
        'Bank/Source',
        'Account Number',
        'Total Records',
        'Matched Records',
        'Unmatched Records',
        'Match Rate (%)',
        'Total Amount',
        'Matched Amount',
        'Reason',
        'Status',
        'Uploaded By',
        'Upload Date'
      ];

      let csv = 'RECONCILIATION REPORT\n';
      csv += 'Generated on: ' + new Date().toLocaleString() + '\n';
      csv += 'Total Records: ' + this.total + '\n';
      csv += '\n';

      csv += 'SUMMARY STATISTICS\n';
      csv += 'Total Reconciliations,' + this.statistics.total_reconciliations + '\n';
      csv += 'Total Amount,ETB ' + this.formatAmount(this.statistics.total_amount) + '\n';
      csv += 'Total Matched Amount,ETB ' + this.formatAmount(this.statistics.total_matched) + '\n';
      csv += 'Total Unmatched Amount,ETB ' + this.formatAmount(this.statistics.total_unmatched) + '\n';
      csv += 'Average Match Rate,' + this.statistics.avg_match_rate.toFixed(2) + '%\n';
      csv += '\n';

      if (this.hasActiveFilters) {
        csv += 'APPLIED FILTERS\n';
        if (this.filters.startDate) csv += 'Start Date,' + this.filters.startDate + '\n';
        if (this.filters.endDate) csv += 'End Date,' + this.filters.endDate + '\n';
        if (this.filters.status) csv += 'Status,' + this.filters.status + '\n';
        if (this.filters.bankSource) csv += 'Bank Source,' + this.filters.bankSource + '\n';
        if (this.searchQuery) csv += 'Search Query,' + this.searchQuery + '\n';
        csv += '\n';
      }

      csv += 'RECONCILIATION DATA\n';
      csv += headers.join(',') + '\n';

      this.reconciliations.forEach((reconciliation, index) => {
        const row = [
          index + 1,
          reconciliation.document_name,
          this.formatDateDisplay(reconciliation.period),
          reconciliation.bank_source,
          reconciliation.bank_account || 'N/A',
          reconciliation.total_records,
          reconciliation.matched_records,
          reconciliation.unmatched_records,
          reconciliation.match_percentage || 0,
          'ETB ' + this.formatAmount(reconciliation.total_amount),
          'ETB ' + this.formatAmount(reconciliation.matched_amount),
          reconciliation.reason,
          reconciliation.status,
          reconciliation.uploaded_by,
          this.formatDateTimeDisplay(reconciliation.upload_date)
        ];
        csv += row.map(field => this.escapeCSVField(field)).join(',') + '\n';
      });

      return csv;
    },

    escapeCSVField(field) {
      if (field === null || field === undefined) {
        return '';
      }

      field = field.toString();

      if (field.includes(',') || field.includes('\n') || field.includes('"')) {
        field = field.replace(/"/g, '""');
        return `"${field}"`;
      }

      return field;
    },

    closeUploadModal() {
      this.showUploadModal = false;
      this.selectedFile = null;
      this.filePreview = [];
      this.uploadData = {
        documentName: '',
        period: '',
        bankSource: '',
        bankAccount: '',
        reason: ''
      };
      this.uploadError = '';
    },

    closeDetailsModal() {
      this.showDetailsModal = false;
      this.selectedReconciliation = null;
      this.reconciliationDetails = null;
    },

    // Utility methods
    formatDate(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },

    formatDateTime(dateString) {
      if (!dateString) return '-';
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },

    formatAmount(amount) {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount || 0);
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    },

    maskAccountNumber(accountNumber) {
      if (!accountNumber) return '-';
      const length = accountNumber.length;
      if (length <= 4) return accountNumber;
      return '*'.repeat(length - 4) + accountNumber.slice(-4);
    },

    getFileIcon(fileType) {
      return 'fas fa-file-csv text-primary';
    },

    getStatusBadge(status) {
      const badges = {
        'complete': 'badge bg-success',
        'processing': 'badge bg-warning',
        'failed': 'badge bg-danger'
      };
      return badges[status] || 'badge bg-secondary';
    },

    getMatchRateBadge(percentage) {
      if (percentage >= 90) return 'badge bg-success';
      if (percentage >= 70) return 'badge bg-info';
      if (percentage >= 50) return 'badge bg-warning';
      return 'badge bg-danger';
    },

    getProgressBarClass(percentage) {
      if (percentage >= 90) return 'bg-success';
      if (percentage >= 70) return 'bg-info';
      if (percentage >= 50) return 'bg-warning';
      return 'bg-danger';
    },

    // Alert methods
    clearAlerts() {
      this.alert.success = false;
      this.alert.info = false;
      this.alert.failed = false;
    },

    showAlert(type, message) {
      this.clearAlerts();
      this.alert[type] = true;
      this.message = message;

      if (type === 'success' || type === 'info') {
        setTimeout(() => {
          this.clearAlerts();
        }, 5000);
      }
    }
  }
};
</script>

<style scoped>
.spinner-border {
  width: 2rem;
  height: 2rem;
}

.modal.show {
  display: block !important;
}

.search-icon {
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: #999;
}

.file-drop-zone {
  border: 2px dashed #dee2e6;
  border-radius: 0.375rem;
  padding: 3rem;
  text-align: center;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
  background-color: #f8f9fa;
}

.file-drop-zone:hover {
  border-color: #adb5bd;
  background-color: #e9ecef;
}

.file-drop-zone.drag-active {
  border-color: #0d6efd;
  background-color: #e7f1ff;
}

.progress {
  background-color: #e9ecef;
}

.table-responsive {
  min-height: 300px;
}

.avatar-title {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-weight: 600;
}

.alert {
  min-width: 300px;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.file-drop-zone i {
  display: block;
}

.table td {
  vertical-align: middle;
}

.progress-bar {
  font-weight: 600;
  font-size: 0.75rem;
}

.modal {
  backdrop-filter: blur(3px);
}

@media (max-width: 768px) {
  .filter-tool-bar-btns {
    flex-wrap: wrap;
  }

  .filter-tool-bar-btns .btn {
    margin-bottom: 0.5rem;
  }

  .table-responsive {
    font-size: 0.875rem;
  }
}
</style>